// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1MCGY","legacyBtn":"MutateMid_legacyBtn__3YsnG"};